
        // Make API auth token available globally (not needed for this endpoint - uses "No Auth")
        window.API_AUTH_TOKEN = import.meta.env?.VITE_API_AUTH_TOKEN || '';
    